module.exports = __webpack_public_path__ + "img/cxample_18.048394c6.png";